





















import { Prop, Component, Vue } from 'vue-property-decorator'
import { gsap } from 'gsap'

@Component
export default class CollapsibleHeader extends Vue {
    @Prop({ required: false }) title!: string
    @Prop({ type: Boolean, default: false }) startOpen!: boolean

    open: boolean = false

    created(): void {
        this.open = this.startOpen
    }

    toggleOpen(): void {
        this.open = !this.open
    }

    animateShow(element: HTMLDivElement, onComplete: () => void) {
        gsap.set(element, {
            opacity: 0,
            height: 0,
        })

        gsap.to(element, {
            duration: .2,
            opacity: 1,
            height: 'auto',
            onComplete,
        })
    }

    animateHide(element: HTMLDivElement, onComplete: () => void) {
        gsap.to(element, {
            duration: .2,
            opacity: 0,
            height: 0,
            onComplete,
        })
    }
}
